import React from "react";

export default function SolarBellLinear(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M18.75 9.71v-.705C18.75 5.136 15.726 2 12 2S5.25 5.136 5.25 9.005v.705a4.4 4.4 0 0 1-.692 2.375L3.45 13.81c-.952 1.578-.238 3.64 1.517 4.134c1.28.36 2.63.62 4.033.764c.422.044.845.08 1.27.11c.838.058 1.68.058 2.46 0c.425-.03.848-.066 1.27-.11c1.403-.144 2.753-.404 4.033-.764c1.755-.494 2.469-2.556 1.517-4.134l-1.108-1.725a4.4 4.4 0 0 1-.692-2.375Z"></path>
        <path strokeLinecap="round" d="M7.5 19c.655 1.748 2.422 3 4.5 3s3.845-1.252 4.5-3"></path>
      </g>
    </svg>
  );
}
